import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-62a7404b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header align-items-center" }
const _hoisted_3 = { class: "card-body" }
const _hoisted_4 = { class: "table-responsive" }
const _hoisted_5 = { class: "table table-bordered table-sm" }
const _hoisted_6 = { class: "fw-bold text-primary border-bottom-2 border-primary" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "ps-5" }, "Turno", -1 /* HOISTED */))
const _hoisted_8 = { class: "border" }
const _hoisted_9 = { class: "pt-5 ps-5" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-footer d-flex justify-content-end" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "submit",
    class: "btn btn-primary"
  }, "Salvar")
], -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputCustom = _resolveComponent("InputCustom")!
  const _directive_mask = _resolveDirective("mask")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("form", {
      onSubmit: _withModifiers($setup.setDadosTabela, ["prevent"])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h3", null, _toDisplayString($setup.nomeEnsino), 1 /* TEXT */)
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("table", _hoisted_5, [
            _createElementVNode("thead", _hoisted_6, [
              _createElementVNode("tr", null, [
                _hoisted_7,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.header, ({ turno }, index) => {
                  return (_openBlock(), _createElementBlock("th", {
                    key: turno + index,
                    class: "ps-5"
                  }, _toDisplayString(turno), 1 /* TEXT */))
                }), 128 /* KEYED_FRAGMENT */))
              ])
            ]),
            _createElementVNode("tbody", _hoisted_8, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.body, ({ title, values }, index) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: title + index
                }, [
                  _createElementVNode("td", _hoisted_9, _toDisplayString(title), 1 /* TEXT */),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.header, ({ turno }, index) => {
                    return (_openBlock(), _createElementBlock("td", {
                      key: index,
                      class: "ps-5"
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(values, (value) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: value.id
                        }, [
                          (turno == value.fase)
                            ? _withDirectives((_openBlock(), _createBlock(_component_InputCustom, {
                                key: 0,
                                modelValue: $setup.form.input[`id_${value.id}`],
                                "onUpdate:modelValue": ($event: any) => (($setup.form.input[`id_${value.id}`]) = $event),
                                class: "p-1 widthInput"
                              }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue"])), [
                                [_directive_mask, _ctx.mask]
                              ])
                            : _createCommentVNode("v-if", true)
                        ]))
                      }), 128 /* KEYED_FRAGMENT */))
                    ]))
                  }), 128 /* KEYED_FRAGMENT */))
                ]))
              }), 128 /* KEYED_FRAGMENT */))
            ])
          ])
        ])
      ]),
      _hoisted_10
    ], 32 /* NEED_HYDRATION */)
  ]))
}